module.exports = __webpack_public_path__ + "img/50.21604f28.png";